export default {"src":"/_next/static/media/leo.3f53b42f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};